import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/pv_check_preview.jpg")